import { OmniPickerRow } from "@/components/artifacts/omni/OmniPickerRow.tsx";
import type { WhatsappPickerGroup } from "@/types/whatsappGroups.ts";
import { Users } from "lucide-react";

type Props = {
  groups: WhatsappPickerGroup[];
  isSelected: (group: WhatsappPickerGroup) => boolean;
  isCapped: (group: WhatsappPickerGroup) => boolean;
  onToggle: (groupId: string) => void;
  disabled?: boolean;
};

/**
 * The WhatsApp groups the user runs, each a checkbox row. A group okthx is
 * already in is shown checked and locked: there is nothing to add, and taking
 * okthx out is a WhatsApp action, not this picker's.
 */
export const WhatsappGroupChecklist = ({
  groups,
  isSelected,
  isCapped,
  onToggle,
  disabled,
}: Props) => (
  <>
    {groups.map((group) => {
      const qualifier = group.okthxIsMember ? "okthx is here" : memberCount(group.size);
      return (
        <OmniPickerRow
          key={group.id}
          checked={isSelected(group)}
          onToggle={() => onToggle(group.id)}
          disabled={disabled || isCapped(group)}
          locked={group.okthxIsMember}
          leading={<Users className="size-3.5 text-muted-foreground" />}
          label={group.subject || "Unnamed group"}
          qualifier={qualifier}
          ariaState={qualifier}
          statsigName="whatsapp-group-picker-row"
        />
      );
    })}
  </>
);

/** "1 member", "12 members". */
function memberCount(size: number): string {
  return `${size} ${size === 1 ? "member" : "members"}`;
}
